import {WebDokuNodeValue} from "./web-doku-node-value";
import {LDWDocument} from "./LDWDocument";

export class DocumentDetail extends LDWDocument{
  public additionalInfos: WebDokuNodeValue[] = [];
  public created ="";
  public createdBy ="";
  public job ="";
}
